// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__ButtonPrimary from "../../components/html/ButtonPrimary.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function SignModal(Props) {
  let onClose = Props.onClose;
  let onSignClicked = Props.onSignClicked;
  let participant = Props.participant;
  const refCert = React.useRef(null);
  const match = participant.signer_type;
  let signerTypeStr;
  switch (match) {
    case /* SIGNER_ENTITY_TYPE_UNSPECIFIED */ 0 :
      signerTypeStr = "Неизвестный тип";
      break;
    case /* SIGNER_ENTITY_TYPE_INDIVIDUAL */ 1 :
      signerTypeStr = "ИИН";
      break;
    case /* SIGNER_ENTITY_TYPE_ORGANIZATION */ 2 :
      signerTypeStr = "БИН";
      break;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.H4.make, {
              children: "Подписать с помощью ЭЦП"
            }),
            JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx("img", {
                className: "w-6 h-6",
                src: StaticAsset.src("/static/icons/close.svg")
              }),
              onClick: (function (param) {
                Curry._1(onClose, undefined);
              })
            })
          ],
          className: "px-6 py-4 flex justify-between border-b border-gray-main"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              alt: "key",
              src: StaticAsset.src("/static/icons/key-gray-40.svg")
            }),
            JsxRuntime.jsx(Buhta_components__Text.H3.make, {
              className: "mt-6",
              children: "Подписать с помощью ЭЦП"
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "mt-2 text-asphalt",
              children: "Необходимо подключить модуль Бухта в настройках NCALayer"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                  children: Belt__Belt_Option.getExn(participant.name)
                }),
                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                  children: "" + signerTypeStr + " " + Belt__Belt_Option.getExn(participant.tin)
                })
              ],
              className: "mt-6 px-6 py-2 w-[320px] bg-gray-pale rounded-sm flex flex-col gap-1 justify-center items-center"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_cabinet__ButtonPrimary.make, {
                title: "Начать подписание",
                onClick: (function (param) {
                  Curry._1(onSignClicked, undefined);
                }),
                reference: refCert,
                className: "w-[320px] px-3 py-2 justify-center"
              }),
              className: "mt-6"
            })
          ],
          className: "flex flex-col items-center py-10"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
            className: "text-asphalt text-center",
            children: [
              "Если у вас не установлено приложение NCALayer, то его можно скачать на ",
              JsxRuntime.jsx("a", {
                children: "официальном сайте",
                className: "text-links",
                href: "https://ncl.pki.gov.kz/",
                target: "_blank"
              })
            ]
          }),
          className: "flex justify-center px-6 py-4 bg-gray-pale rounded-b"
        })
      ],
      className: "w-120 bg-white rounded-sm shadow-payroll"
    }),
    className: "absolute inset-0 bg-black/40 flex justify-center items-center z-10"
  });
}

const make = SignModal;

export {
  make,
}
/* Buhta_cabinet__ButtonPrimary Not a pure module */
